import { PropTypes } from 'prop-types';
import Utils from '@/common/utils/utils';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';
import AttachFileThumbnail from '@/component/common/AttachFileThumbnail/components/AttachFileThumbnail';

function EmailImageAttachment({ item, detailTicket, thumbnailSize, setOpenPreviewImage, setOpenFileOption, setOpenOption }) {
    if (!item) return null;

    const imgLink = getLinkDownloadFileFromS3({ ...item, type: 1 }, detailTicket);

    return (
        <li className="justify-content-center">
            <div className="display-thumb">
                <AttachFileThumbnail
                    fileName={item.fileName}
                    fileSize={item.fileSize}
                    fileKey={item.fileUrl}
                    imageUrl={Utils.isImageFile(item.fileName) ? imgLink : undefined}
                    size={thumbnailSize}
                    onClickFile={() => setOpenPreviewImage(imgLink)}
                    onClickMore={e => {
                        setOpenFileOption({
                            ...detailTicket.attachFiles.find(
                                i => i.fileInfo.fileUrl === item?.fileUrl
                            )
                        });
                        setOpenOption(e.currentTarget);
                    }}
                />
            </div>
        </li>
    );
}

EmailImageAttachment.propTypes = {
    item: PropTypes.any,
    detailTicket: PropTypes.any,
    thumbnailSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setOpenPreviewImage: PropTypes.func,
    setOpenFileOption: PropTypes.func,
    setOpenOption: PropTypes.func
};

export default EmailImageAttachment;

